export default "__VITE_ASSET__BwYBhpod__"